// @flow
import React from 'react'

type ValidatorScriptProps = {
  handleScriptCreate: Function,
  handleScriptError: Function,
  handleScriptLoad: Function,
  id: string,
  notCheckUrl?: boolean,
  shouldRemove: boolean,
  url: string,
}

type ValidatorScriptState = {
  prevUrl: string,
}

export default class ValidatorScript extends React.Component<ValidatorScriptProps, ValidatorScriptState> {

  static initScript = (props: ValidatorScriptProps, pushRemove: boolean = false) => {
    const { id, url, shouldRemove } = props
    const { handleScriptCreate, handleScriptLoad, handleScriptError } = props

    const previousValidatorScript = document.getElementById(id)
    const dataTime = previousValidatorScript && previousValidatorScript.dataset.time
      ? parseInt(previousValidatorScript.dataset.time, 0)
      : 0
    if (dataTime < Date.now() - 300000 || shouldRemove || pushRemove) {
      if (previousValidatorScript !== null) {
        if (previousValidatorScript !== null) {
          if (!('remove' in Element.prototype)) {
            Element.prototype.remove = function () {
              if (this.parentNode) {
                this.parentNode.removeChild(this)
              }
            }
          }
        }
        previousValidatorScript.remove()
      }
      handleScriptCreate()

      const script = document.createElement('script')

      script.id = id
      script.src = url
      script.async = true
      script.onload = handleScriptLoad
      script.onerror = handleScriptError
      script.setAttribute('data-time', `${Date.now()}`)

      document.body.appendChild(script)
    } else {
      previousValidatorScript.addEventListener('load', handleScriptLoad, false)
      handleScriptLoad()
    }
  }

  static defaultProps = {
    shouldRemove: false,
    notCheckUrl: false,
  }

  constructor(props: ValidatorScriptProps) {
    super(props)
    ValidatorScript.initScript(props)

    this.state = {
      prevUrl: props.url
    }
  }

  static getDerivedStateFromProps = (nextProps: ValidatorScriptProps, prevState: ValidatorScriptState) => {
    if (prevState.prevUrl !== nextProps.url && !nextProps.notCheckUrl) {
      ValidatorScript.initScript(nextProps, true)
      return {
        prevUrl: nextProps.url
      }
    }
    return null
  }

  render() {
    return null
  }
}
